import { render } from "./phone-input.vue?vue&type=template&id=44de4da4"
import script from "./phone-input.vue?vue&type=script&setup=true&lang=js"
export * from "./phone-input.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/components/form/phone-input.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44de4da4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44de4da4', __exports__)) {
    console.log('reload')
    api.reload('44de4da4', __exports__)
  }
  
  module.hot.accept("./phone-input.vue?vue&type=template&id=44de4da4", () => {
    console.log('re-render')
    api.rerender('44de4da4', render)
  })

}


export default __exports__